import { trackAutoEvent } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'page_inaction';

export default (intervalParams) => {
  trackAutoEvent(EVENT_NAME, intervalParams, {});
};



// WEBPACK FOOTER //
// ./src/lib/track-event/page-inaction.js